export abstract class Effect {
    id?: number;

    /**
     * How long the effect should be applied, 0 for forever.
     */
    duration: number;

    /**
     * A factor that is applied to the width of the player.
     */
    width?: number;

    /**
     * A factor that is applied to the speed of the player moving left.
     */
    speedLeft?: number;

    /**
     * A factor that is applied to the speed of the player moving right.
     */
    speedRight?: number;

    constructor() {
        this.duration = 2000 + 10000*Math.random();
    }

    abstract toString(): string;
}

export class Slower extends Effect {
    public speedLeft = .5;
    public speedRight = .5;

    toString() {
        return 'effect Slower';
    }
}

export class Smaller extends Effect {
    public width = .2;

    toString() {
        return 'effect Smaller';
    }
}

export class Inverted extends Effect {
    public speedLeft = -1;
    public speedRight = -1;

    toString() {
        return 'effect Inverted';
    }
}

export class Hyper extends Effect {
    public width = 2;
    public speedLeft = 2;
    public speedRight = 2;

    toString() {
        return 'effect Hyper';
    }
}
